import { Component, Input } from '@angular/core';
import { UiCartComponent } from '../ui-cart/ui-cart.component';
import { SelectService } from '../../services/select.service';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';

@Component({
    selector: 'view-user-cart',
    templateUrl: './view-user-cart.component.html',
    styleUrls: ['./view-user-cart.component.css'],
    imports: [UiCartComponent]
})
export class ViewUserCartComponent {

  constructor(private route: ActivatedRoute, private ssv: SelectService) {

  }

  ngOnInit() {

    const productId = this.route.snapshot.url.join('/');
    if (_.isString(productId) && productId.length > 0)
    {
      if (!this.ssv.isSelected(productId))
        this.ssv.select(productId, 1);
    }

  }

}
